module.exports = __webpack_public_path__ + "static/media/B_F02.f01190bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/B_F02.png
// module id = 90
// module chunks = 0